import { Button } from '@com-delta-idp/mnx-ui-kit';
import { DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';

export interface Summary extends DisplayProperties {
  header: string;
  label: string;
  title: string;
  description: string;
  action: Button;
}
